<template lang="pug">
app-modal.modalSolicitarDeclaracao(
  titulo="Solicitar Declaração de trâmite processual"
  :closeOutside="false"
  @closeModal="$emit('closeModal')"
)
  template(slot="body")
    validation-observer(ref="observerDeclaracao")
      validation-provider(rules="required" v-slot="{ errors }", name="Motivo")
        app-label(label="Informe a finalidade para solicitação da declaração de trâmite processual:")
        el-select.select.input(
          v-model="motivoDeclaracao"
          class="select",
          value-key="id",
          name="motivos"
          placeholder="Selecione",
          clearable
          :class="{'erro' : errors.length}"
        )
          el-option.selectOption(
            v-for="item in motivos"
            :key="item.id"
            :label="item.nome"
            :value="item"
          )
        span.help.erro {{ errors[0] }}

      div.container-input(v-if="motivoDeclaracao && motivoDeclaracao.nome.indexOf('Outro') === 0")
        validation-provider(rules="required" v-slot="{ errors }", name="Motivo")
          app-label(label="Qual outra finalidade?:")
          el-input.input(v-model="outroMotivo" :class="{'erro' : errors.length}")
          span.help.erro {{ errors[0] }}

  template(slot="footer")
    div.buttons
      el-button(
        type="default",
        @click="$emit('closeModal')"
      ) Cancelar
      el-button(
        type="primary",
        @click="gerar"
      ) Confirmar
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppModal,
    AppLabel
  },

  mixins: [AppNotificacao],

  props: {
    numeroProcesso: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      motivos: [],
      motivoDeclaracao: null,
      outroMotivo: ''
    }
  },

  async created () {
    this.motivos = await this.getMotivos()
  },

  methods: {
    ...mapActions({
      getMotivos: 'declaracaoTramite/getMotivos',
      gerarDeclaracao: 'declaracaoTramite/gerarDeclaracao'
    }),

    async gerar () {
      const valid = await this.$refs.observerDeclaracao.validate()

      if (valid) {
        await this.gerarDeclaracao({ motivoDeclaracao: this.motivoDeclaracao, numeroProcesso: this.numeroProcesso, outroMotivo: this.outroMotivo })

        this.$emit('closeModal')
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 780px) {
  .modalSolicitarDeclaracao {
    position: fixed;
  }

  .selectOption {
    left: 36px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/GerarDeclaracaoTramite.vue